import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { contexts } from 'constants/contexts';
import { setContext } from 'modules/labs/common/actions';
import LabsView from 'modules/labs/laboratories/views/LabsView';
import { fetchAllLabsWithFilters } from 'modules/labs/laboratories/actions';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const VendorPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const allLabsQueryStrings = useMemo(
    () => ({
      includes: 'Translators',
      pageNumber: 1,
      PageSize: 5,
    }),
    [],
  );
  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################

  useEffect(() => {
    dispatch(setContext(contexts.vendors));
    dispatch(fetchAllLabsWithFilters(allLabsQueryStrings));
  }, [dispatch, allLabsQueryStrings]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <LabsView allLabsQueryStrings={allLabsQueryStrings} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

VendorPage.propTypes = {};

VendorPage.defaultProps = {};

export default VendorPage;
